import { serverAjaxPromise } from './request_helpers';
import { getActivityByValue } from '../activity_util';

export const updateTrack = (slug, trailId, { name, description, activity, date, rating, isPrivate, contentPrivacy }, flexiblePrivacyFeatureFlag) => {
  const data = {
    rating,
    at_map: {
      name,
      description,
      activity: activity.value,
      created_at: date.toISOString().slice(0, 10),
      trail_id: trailId
    }
  };

  if (flexiblePrivacyFeatureFlag) {
    Object.assign(data, { at_map: { ...data.at_map, contentPrivacy } });
  } else {
    Object.assign(data, { at_map: { ...data.at_map, private: isPrivate ? '1' : '0' } });
  }

  return serverAjaxPromise({
    method: 'PUT',
    url: `/explore/recording/${slug}`,
    data,
    dataType: 'json',
    resReducer: res => res.maps
  });
};

export const deleteTrack = mapId => {
  return serverAjaxPromise({
    method: 'DELETE',
    url: `/api/alltrails/maps/${mapId}`,
    resReducer: res => res
  });
};

export const getEditTrackParams = url => {
  return serverAjaxPromise({
    method: 'GET',
    url,
    dataType: 'json',
    resReducer: res => {
      return {
        trackParams: {
          name: res.track.name,
          description: res.track.description,
          rating: res.track.rating,
          date: new Date(res.track.created_at),
          activity: getActivityByValue(res.activityUid || 'hiking'),
          private: res.track.is_private,
          trailId: res.track.trail_id,
          contentPrivacy: res.track.content_privacy
        },
        initialMap: res.track,
        nearbyTrails: res.nearbyTrails.map(({ trail }) => ({ value: trail.trail_id, label: trail.name }))
      };
    }
  });
};
